import { ICalendarEventDto } from 'gen/ApiClient';

export const filterEvents = (events: ICalendarEventDto[], selectedUserResourceKeys: string[]) => {
	return events.filter(t => selectedUserResourceKeys.some(x => t.userGroupKeys.indexOf(x) !== -1));
};
